/* eslint-disable max-len */
/* eslint-disable react/no-array-index-key */
/* eslint-disable no-plusplus */
import React from 'react';

import useProfileImage from '@/hooks/useProfileImage';

// // Function to render circles based on layers
// export function renderCirclesWithLocation(circleArray) {
//     // Array to store rendered circles
//     const circles = [];
//     // Identifier for each circle
//     let id = 0;
//
//     // Iterate over each layer of circles
//     circleArray.forEach((circle) => {
//         circles.push(
//             <g key={id++}>
//                 <defs>
//                     <clipPath id={`clip-circle-${id}`}>
//                         <circle cx={circle.x} cy={circle.y} r={circle.circleRadius} />
//                     </clipPath>
//                 </defs>
//                 <circle
//                     cx={circle.x}
//                     cy={circle.y}
//                     r={circle.circleRadius + 2}
//                     stroke={circle.strokeColor}
//                     strokeWidth="3"
//                 />
//                 <image
//                     x={circle.x - circle.circleRadius}
//                     y={circle.y - circle.circleRadius}
//                     width={circle.circleRadius * 2}
//                     height={circle.circleRadius * 2}
//                     href="/images/default-gravatar.svg"
//                     clipPath={`url(#clip-circle-${id})`}
//                 />
//             </g>,
//         );
//     });
//
//     // Return the array of rendered circles
//     return circles;
// }

// Function to render circles based on layers
export function renderCirclesWithoutLocation(circleLayers, circleBase, width) {
    if (circleLayers === null) {
        return null;
    }
    // Array to store rendered circles
    const circles = [];
    // Identifier for each circle
    let id = 0;
    // Array to keep track of used positions to prevent overlapping
    const usedPositions = [];

    // Iterate over each layer of circles
    circleLayers.forEach((layer) => {
        layer.contacts.forEach((contact) => {
            // Coordinates for circle center
            let x;
            let y;
            // Flag to check if current circle overlaps with others
            let isColliding;

            const circleRadius = Math.floor(Math.random() * (width * 0.02 - width * 0.005 + 1)) + width * 0.01;
            // console.log(circleRadius)

            // Generate random positions for circles, ensuring they don't overlap
            do {
                // Random angle for polar coordinates
                const angle = Math.random() * Math.PI * 2;
                // Random radius within layer bounds
                const randomRadius = Math.random() * (layer.maxRadius - layer.minRadius) + layer.minRadius;
                // Calculate x-coordinate
                x = randomRadius * Math.cos(angle) + circleBase.x;
                // Calculate y-coordinate
                y = randomRadius * Math.sin(angle) + circleBase.y;

                // Reset collision flag
                isColliding = false;

                // Check for collisions with previously placed circles
                for (let j = 0; j < usedPositions.length; j++) {
                    // X-coordinate of another circle
                    const otherX = usedPositions[j].x;
                    // Y-coordinate of another circle
                    const otherY = usedPositions[j].y;
                    // Calculate distance between centers
                    const distance = Math.sqrt((x - otherX) ** 2 + (y - otherY) ** 2);

                    // If distance is less than twice the circle's radius
                    // (considering the radius of both circles), they are overlapping

                    if (distance < circleRadius + usedPositions[j].circleRadius + 2) {
                        // Set collision flag to true
                        isColliding = true;
                        // Exit the loop since collision is found
                        break;
                    }
                }
            } while (isColliding); // Repeat until a non-overlapping position is found

            // Define radius for each circle randomly within a range (this will be obtained from data in the future)
            // Store the position to prevent future overlaps
            usedPositions.push({ x, y, circleRadius });

            const { image } = useProfileImage(contact);

            // Render circles with clip-path for circular images
            circles.push(
                <g key={id++}>
                    <defs>
                        <clipPath id={`clip-circle-${id}`}>
                            <circle cx={x} cy={y} r={circleRadius} />
                        </clipPath>
                    </defs>
                    <circle
                        cx={x}
                        cy={y}
                        r={circleRadius + 2}
                        stroke="green"
                        strokeWidth="3"
                    />
                    <image
                        x={x - circleRadius}
                        y={y - circleRadius}
                        width={circleRadius * 2}
                        height={circleRadius * 2}
                        href={image}
                        clipPath={`url(#clip-circle-${id})`}
                    />
                </g>,
            );
        });
    });

    // Return the array of rendered circles
    return circles;
}

// Function to render the background circles
export function renderCircleBase(circleBase) {
    return circleBase.layers.map((layer, index) => (
        <circle key={index} cx={circleBase.x} cy={circleBase.y} r={layer.radius} fill={layer.color} />
    ));
}
